<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'rounds.configureRounds' | translate }}</h2>
      <p class="text-muted small mb-0">{{ eventClass.class_name }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    @if (loading) {
      <div class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else {
      <!-- Rounds List -->
      <div class="rounds-list mb-4">
        @if (rounds.length === 0) {
          <div class="text-center py-4 text-muted">
            <i class="fa fa-layer-group fs-2x mb-3 d-block opacity-50"></i>
            <p class="mb-0">{{ 'rounds.noRounds' | translate }}</p>
          </div>
        } @else {
          @for (round of rounds; track round.round_id) {
            <div class="round-item" [class.editing]="editingRound?.round_id === round.round_id">
              @if (editingRound?.round_id === round.round_id) {
                <!-- Edit Mode -->
                <form [formGroup]="form" (ngSubmit)="saveRound()" class="edit-form">
                  <div class="round-number">#{{ round.round_number }}</div>
                  <div class="flex-grow-1">
                    <app-input-component
                      [label]="'rounds.roundName' | translate"
                      [type]="'text'"
                      [value]="form.get('round_name')?.value"
                      (valueChange)="form.get('round_name')?.setValue($event)"
                      [floating]="true"
                    ></app-input-component>
                  </div>
                  <div class="edit-actions">
                    <button type="button" class="btn btn-sm btn-light" (click)="cancelEdit()">
                      <i class="fa fa-times"></i>
                    </button>
                    <button type="submit" class="btn btn-sm btn-primary" [disabled]="saving">
                      @if (saving) {
                        <span class="spinner-border spinner-border-sm" role="status"></span>
                      } @else {
                        <i class="fa fa-check"></i>
                      }
                    </button>
                  </div>
                </form>
              } @else {
                <!-- View Mode -->
                <div class="round-info">
                  <div class="round-number">#{{ round.round_number }}</div>
                  <div class="round-details">
                    <span class="round-name">{{ round.round_name || 'Round ' + round.round_number }}</span>
                    <span class="badge" [ngClass]="getRoundStatusClass(round)">
                      {{ getRoundStatusLabel(round) }}
                    </span>
                  </div>
                </div>
                <div class="round-actions">
                  <button
                    type="button"
                    class="btn btn-sm btn-icon btn-light"
                    (click)="startEdit(round)"
                    [disabled]="editingRound !== null"
                  >
                    <i class="fa fa-pen"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-icon btn-light-danger"
                    (click)="deleteRound(round)"
                    [disabled]="editingRound !== null || round.status !== 'pending'"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              }
            </div>
          }
        }
      </div>

      <!-- Add Round Button -->
      <button
        type="button"
        class="btn btn-light-primary w-100"
        (click)="addRound()"
        [disabled]="saving || editingRound !== null"
      >
        @if (saving) {
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
        } @else {
          <i class="fa fa-plus me-2"></i>
        }
        {{ 'rounds.addRound' | translate }}
      </button>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="close()">
      {{ 'common.done' | translate }}
    </button>
  </div>
</div>
